module.exports = __webpack_public_path__ + "static/img/v70.21bbc37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/v70.png
// module id = ZXXy
// module chunks = 1